import { render, staticRenderFns } from "./MedicalRecordModel.vue?vue&type=template&id=82ec6806&scoped=true&"
import script from "./MedicalRecordModel.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordModel.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordModel.vue?vue&type=style&index=0&id=82ec6806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ec6806",
  null
  
)

export default component.exports